const TypeUtils = {
  Object: {
    keys: <T extends Record<string, unknown>>(obj: T): (keyof T)[] => Object.keys(obj) as (keyof T)[],
    values: <T extends Record<string, unknown>>(obj: T): T[keyof T][] => Object.values(obj) as T[keyof T][],
  },
  exhaustiveCheck: (_param: never): void => undefined,
};

export { TypeUtils };
